import React, { PureComponent } from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import DateTime from 'components/DateTime';

class GanttChartScaleWeeks extends PureComponent {
    getNextMonthFirstDay(date) {
        const index = this.chartDays.findIndex(day => day.clone().startOf('month').diff(date.clone().startOf('month'), 'months') > 0);

        if (index === -1) {
            return this.chartDays.length;
        }

        return index;
    }

    getNextWeekFirstDay(date) {
        const index = this.chartDays.findIndex(day => day.clone().startOf('week').diff(date.clone().startOf('week'), 'weeks') > 0);

        if (index === -1) {
            return this.chartDays.length;
        }

        return index;
    }

    getWeekNumber(date) {
        return date.diff(date.clone().startOf('month'), 'weeks') + 1;
    }

    get chartDays() {
        return new Array(this.props.chartDuration).fill(0).map((item, index) => this.props.chartStart.clone().add(index, 'days'));
    }

    render() {
        if (!this.props.chartStart || !this.props.chartDuration) {
            return null;
        }

        const { t } = this.props;

        let secLastDay;
        let lastDay;

        return (
            <div className="gantt-chart-scale">
                <div className="scale-items-secondary">
                    {
                        this.chartDays.map((date, index) => {
                            if (secLastDay && date.isSame(secLastDay, 'month')) {
                                return null;
                            }

                            secLastDay = date;

                            const startPx = index * this.props.scaleItemWidth;
                            const endPx = this.getNextMonthFirstDay(date) * this.props.scaleItemWidth;

                            return <div className="scale-item-secondary" key={index} style={{left: `${startPx}px`, width: `${endPx - startPx}px`}}>
                                <DateTime format="MMMM">{ date.toDate() }</DateTime>
                            </div>
                        })
                    }
                </div>

                <div className="scale-items">
                    {
                        this.chartDays.map((date, index) => {
                            if (lastDay && date.clone().startOf('week').isSame(lastDay.clone().startOf('week'), 'day')) {
                                return null;
                            }

                            lastDay = date;

                            return (
                                <div className={'scale-item' + (date.clone().startOf('week').isSame(moment().startOf('week'), 'day') ? ' today': '')} key={index} style={{width: `${this.props.scaleItemWidth * 7}px`}}>
                                    <div className="scale-item-inner">
                                        <span>{ t('WEEK Number', { number: moment(date).format('W') }) }</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export default withTranslation('date')(GanttChartScaleWeeks);
